import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const TeamTable = ({ accountDetail, handleAddTeam }) => {
  return (
    <div className="accounts-roles-table">
      <div className="table-wrapper">
        <div className="table-head">
          <table>
            <thead>
              <tr className="table-row table-row-head">
                <th className="table-cell table-cell-name">
                  <span className="text-left display-block padding-left-15">
                    Team
                  </span>
                </th>
                <th className="table-cell table-cell-date">
                  <span className="text-left display-block padding-left-15">
                    Description
                  </span>
                </th>
                <th className="table-cell table-cell-date">
                  <span className="text-left display-block padding-left-15">
                    Active
                  </span>
                </th>
                <th className="table-cell table-cell-date">
                  <span className="text-left display-block padding-left-15">
                    Updated By
                  </span>
                </th>
                <th className="table-cell table-cell-date">
                  <span className="text-left display-block padding-left-15">
                    Created Date
                  </span>
                </th>
                <th className="table-cell table-cell-date">
                  <span className="text-left display-block padding-left-15">
                    Updated Date
                  </span>
                </th>
              </tr>
            </thead>
          </table>
        </div>

        <div className="table-body">
          <table>
            <tbody>
              {accountDetail.teams.map((team, i) => {
                if (
                  team.name.trim() ||
                  (team.description && team.description.trim())
                ) {
                  return (
                    <tr
                      key={`${accountDetail.accountId}_${i}`}
                      className="table-row table-row-body"
                    >
                      <td className="table-cell table-cell-name">
                        <button
                          onClick={() => handleAddTeam(team)}
                          className="table-cell-button"
                        >
                          <span className="col-text">{team.name}</span>
                        </button>
                      </td>
                      <td className="table-cell table-cell-date">
                        <span className="col-text text-left">
                          {team.description}
                        </span>
                      </td>
                      <td className="table-cell table-cell-date">
                        <span className="col-text text-left">
                          {team.activeStatus === 'Y' ? 'Yes' : 'No'}
                        </span>
                      </td>
                      <td className="table-cell table-cell-date">
                        <span className="col-text text-left">
                          {team.updatedByUser}
                        </span>
                      </td>
                      <td className="table-cell table-cell-date">
                        <span className="col-text text-left">
                          {moment(team.creationDate).format(
                            'MM DD YYYY hh:mm:ss'
                          )}
                        </span>
                      </td>
                      <td className="table-cell table-cell-date">
                        <span className="col-text text-left">
                          {moment(team.updatedDate).format(
                            'MM DD YYYY hh:mm:ss'
                          )}
                        </span>
                      </td>
                    </tr>
                  );
                }
                return null;
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

TeamTable.propTypes = {
  accountDetail: PropTypes.instanceOf(Object),
  handleAddTeam: PropTypes.func,
};

export default TeamTable;
